<template>
  <div id="weChatPayQRcode">
    <div class="box">
      <div style="margin-bottom:70px;font-size:13px">
        <span>
          <b>订单提成功，请尽快付款！</b>
          订单编号：{{$route.query.order}}
        </span>
        <span style="margin-left:20px">
          请在提交订单后
          <span class="lv0Text">2小时</span>内完成付款，否则订单会自动取消
        </span>
      </div>

      <div>
        <el-row>
          <el-col :span="15">
            <div style="padding-top:30px" align="right">
              <div class="b">
                <qrcode-vue :value="code" size="250"></qrcode-vue>
              </div>
            </div>
          </el-col>
          <el-col :span="9">
            <div>
              <el-image
                style="width: 300px; height: 350px"
                :src="serve + '/images/pay.png'"
                fit="cover"
              ></el-image>
            </div>
          </el-col>
        </el-row>
      </div>
      <div style="margin-top:50px">
        <router-link to="/user/orders/1">
          <el-button type="primary" style="margin-right:50px">支付成功</el-button>
        </router-link>
        <router-link to="/help/11">
          <el-button >遇到问题？</el-button>
        </router-link>
        
      </div>
    </div>
  </div>
</template>
<script>
import QrcodeVue from "qrcode.vue";
export default {
  components: {
    QrcodeVue
  },
  data() {
    return {
      //
      serve: this.$store.state.serve,
      code: this.$route.query.qr
    };
  },
  created() {},
  methods: {
    //
  }
};
</script>
<style lang="scss">
#weChatPayQRcode {
  .b {
    border: 4px solid #eee;
    padding: 20px;
    display: inline-block;
  }
  width: 1200px;
  margin: 0 auto;
  padding: 100px 0;
  text-align: center;
  .box {
    background-color: #fff;
    padding: 50px 0 150px 0;
  }
}
</style>